import { makeStyles } from '@material-ui/core/styles';
import ProductImageDecorated from '@sprinx/react-com/ProductImageDecorated';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import useProductAdornmentsMapper from '../../../api/products/useProductAdornmentsMapper';
import ProductDetailLink from '../../../components/ProductDetailLink';
import useProductUrl from '../../../hooks/useProductUrl';

export interface CataloguePageListContentItemRowImageProps
  extends StandardDivProps<CataloguePageListContentItemRowImageClassKey> {
  product: CatalogueProduct;
}

export type CataloguePageListContentItemRowImageClassKey = 'root' | 'image';

const themeSettings = { name: 'CataloguePageListContentItemRowImage' };
const useStyles = makeStyles(
  (theme) => ({
    root: {},
    image: {
      '& > div': {
        width: theme.spacing(12),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
          paddingRight: 0,
          marginBottom: theme.spacing(1),
        },
      },
      '& img': { width: theme.spacing(12) },
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemRowImage = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemRowImageProps
>(({ className, classes: pClasses, product, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const imageAdornments = useProductAdornmentsMapper('row', product.adornments, product);
  const to = useProductUrl(product);

  return (
    <div ref={ref} className={clsx(classes.root, className)} {...rest}>
      <ProductDetailLink to={to}>
        <ProductImageDecorated
          {...imageAdornments}
          src={product.image as any}
          size='normal'
          type='image'
          classes={{ root: classes.image }}
        />
      </ProductDetailLink>
    </div>
  );
});

CataloguePageListContentItemRowImage.displayName = 'CataloguePageListContentItemRowImage';

export default withThemeProps(themeSettings)(CataloguePageListContentItemRowImage);
